/* eslint-disable no-console */

import {register} from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered() {
            console.log('Service worker has been registered.')
            const prodVersion = document.querySelector('p.version')?.innerText;
            const localVersion = localStorage.getItem('version');

            console.log('Local Version:', localVersion)
            console.log('Current Version:', prodVersion)

            if (!prodVersion) {
                const keys = ['token', 'linkAluno', 'linkOperador', 'tipo', 'wss', 'version'];

                keys.forEach(key => {
                    localStorage.removeItem(key);
                })

                location.replace('/')
                return
            }

            if (localVersion !== prodVersion) {
                console.log('New Version!')
                caches.keys().then(cacheNames => {
                    cacheNames.forEach(cacheName => {
                        caches.delete(cacheName);
                    });
                })
                localStorage.setItem('version', prodVersion)

                location.reload(true);
            } else {
                console.log('Version is the same, no need to update')
            }
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated() {
            console.log('New content is available; please refresh.')
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}
